import type { FC } from "react";
import { QuickCalculatorProductTile } from "web_myplann/Dashboard/Components/QuickCalculatorProductTile";
import { QuickCalculatorTileSkeleton } from "web_myplann/Dashboard/Components/QuickCalculatorTileSkeleton";
import type { QuickCalculatorItem } from "web_myplann/Dashboard/Types/QuickCalculator";

type Props = {
	items: QuickCalculatorItem[];
	isLoading: boolean;
	onSelect: (calculator: QuickCalculatorItem) => void;
};

export const QuickCalculatorTileList: FC<Props> = ({
	items,
	isLoading,
	onSelect,
}) => (
	<>
		{isLoading &&
			items.map(({ type }) => <QuickCalculatorTileSkeleton key={type} />)}
		{!isLoading &&
			items.map((calculator) => (
				<QuickCalculatorProductTile
					key={calculator.type}
					calculator={calculator}
					onClick={() => onSelect(calculator)}
				/>
			))}
	</>
);
